import { MaterialModule } from './material/material.module';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { ToastComponent } from './toast/toast.component';
import { LoaderComponent } from './loader/loader.component';
import { DialogComponent } from './dialog/dialog.component';
import { ToastService } from '../../services/toast.service';
import { LoaderService } from '../../services/loader.service';
import { DialogService } from '../../services/dialog.service';
import { UtilService } from '../../services/util.service';
import { CommonModule } from '@angular/common';


@NgModule({

  declarations: [
    ToastComponent,
    LoaderComponent,
    DialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule
  ],
  exports: [
    ToastComponent,
    LoaderComponent,
    DialogComponent,
    CommonModule,
    MaterialModule
  ],
  providers: [
    ToastService,
    LoaderService,
    DialogService
  ]
})
export class UtilModule {

  static forRoot(): ModuleWithProviders<UtilModule> {
    return {
      ngModule: UtilModule,
      providers: [UtilService]
    };
  }
}
